/**
 * Whether `value` contains any ASCII control character (U+0000-U+001F, U+007F).
 * @param {string} value
 * @returns {boolean}
 */
export default function hasControlChars(value) {
  // eslint-disable-next-line no-control-regex
  return /[\u0000-\u001f\u007f]/.test(value);
}
